<div class="tabheadingsoverflow">
  <div class="floatinghead width100">
    <div class="row  margin-bottom-15">
      <div class="col-md-2">
        <h3 class="bluelabel margin-bottom-10">Documents</h3>
      </div>
      <!--<div class="col-md-10">
        <div class="d-flex margin-bottom-15">
          <div class="ml-auto d-inline" *ngIf="_authenticationService.Broker()||_authenticationService.Admin()">
            <label class="custom-checkbox margin-right-15" for="checkbox14">
              <input [(ngModel)]="omapproval" (change)="saveOMApproval(omapproval)" type="checkbox">Offering Memorandum requires approval
              <i></i>
            </label>
            <label class="custom-checkbox margin-right-15" for="checkbox14">
              <input [(ngModel)]="ddapproval" (change)="saveDueDiligenceApproval(ddapproval)" type="checkbox">Due Diligence requires approval
              <i></i>
            </label>
            <label class="custom-checkbox" for="checkbox14">
              <input [(ngModel)]="caApproval" (change)="saveCAApproval(caApproval)" type="checkbox">Confidentiality Agreement requires approval
              <i></i>
            </label>
          </div>
        </div>
      </div>-->
    </div>
    <div class="om-dd-check-wrapper margin-bottom-20 d-felx flex-wrap-wrap">
      <div style="display:inline-block;" class="inline-block margin-bottom-10">
        <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
          <li class="transition">
            <div class="list-filter-div">
              <div class="inner-div">
                <label>
                  Offering Memorandum:
                </label>
                <label class="custom-checkbox margin-right-15" for="checkbox14">
                  <input [(ngModel)]="omapproval" (change)="saveOMApproval(omapproval)" type="checkbox">Requires Approval
                  <i></i>
                </label>
                <label class="custom-checkbox margin-right-15" for="checkbox14">
                  <input [(ngModel)]="caApproval" (change)="saveCAApproval(caApproval,1)" type="checkbox">Requires Confidentiality Agreement
                  <i></i>
                </label>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div style="display:inline-block;" class="inline-block">
        <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
          <li class="transition">
            <div class="list-filter-div">
              <div class="inner-div">
                <label>
                  Due Diligence:
                </label>
                <label class="custom-checkbox margin-right-15" for="checkbox14">
                  <input [(ngModel)]="ddapproval" (change)="saveDueDiligenceApproval(ddapproval)" type="checkbox">Requires Approval
                  <i></i>
                </label>
                <label class="custom-checkbox margin-right-15" for="checkbox14">
                  <input [(ngModel)]="ddCaApproval" (change)="saveCAApproval(ddCaApproval,2)" type="checkbox">Requires Confidentiality Agreement
                  <i></i>
                </label>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="width100 margin-bottom-15">
      <div class="cf">
        <div class="docuemnt-right d-flex align-items-center">
          <div class="ml-auto d-flex">
            <div class="d-flex search-right">
              <div class="search-sec" style="padding-right: 15px">
                <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                <i aria-hidden="true" class="fa fa-search icon"></i>
              </div>
              <div class="select-dropdown multiselectdesign multi-check-dropdown">
                <mat-form-field>
                  <mat-select placeholder="Filter By Category" [(ngModel)]="categoryids" multiple class="materialoption" (ngModelChange)="redrawTable()">
                    @if (categoryids?.length > 1) {
                    <mat-select-trigger>
                      <span>{{ categoryids?.length }} items selected</span>
                    </mat-select-trigger>
                    }
                    <mat-option *ngIf="categoryLst.length === 0" [disabled]="true" class="matoption-nodata">
                      Nothing found
                    </mat-option>
                    @for (category of categoryLst; track category) {
                    <mat-option [value]="category.id" class="materialoption">{{category.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <!--<angular2-multiselect [data]="categoryLst" [(ngModel)]="categoryids" [settings]="defaultTypeSettings" (ngModelChange)="redrawTable()"></angular2-multiselect>-->
              </div>
              <div style="padding-left: 5px">
                <button type="button" class="btn btn-lg btn-addgreen"
                        aria-controls="dropdown-basic" (click)="OpenAddFileSlider(UploadFile, 'portfolioUpload')" tooltip="Upload Files" triggers="mouseenter:mouseleave"
                        placement="left" triggers="mouseenter:mouseleave">
                  Upload
                </button>
              </div>
            </div>
          </div>


        </div>


      </div>



    </div>


  </div>


  <div class="table-responsive margin-bottom-20 margin-top-15">
    <table class="table basictable row-border hover" datatable [dtOptions]="dtoptions">
      <thead>
        <tr>
          <th style="width:50px">#</th>
          <th style="width: 150px">Action</th>
          <th [hidden]="!(_authenticationService.Broker() || _authenticationService.Admin()|| _authenticationService.SuperAdmin())" style="width: 200px">Include In Due Diligence</th>
          <th>Document Title</th>
          <th>Category</th>
          <th>Uploaded By</th>
          <th>Date</th>

        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let doc of propertyDocuments; let i = index">
          <tr [ngClass]="{'highlighted' : doc.Id == doc.MaxValue}">
            <td>
              <p>{{i+1}}</p>
            </td>
            <td>
              <a class="blueone" tooltip="Edit File" href="javascript:void(0);" (click)="openEditModal(EditFile,'',doc.Id,doc.CategoryId)" style="font-size:15px">
                <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
              </a>
                <a *ngIf="doc.FilePath.includes('.pdf')" href="javascript:void(0);" tooltip="Preview" (click)="previews(preview,'pdf-view-modal', doc)" placement="top">
                  <i aria-hidden="true" class="fa fa-eye"></i>
                </a>
                <a [ngClass]="{'disable-link':property.IsDeleted}" *ngIf="doc.FilePath != null && doc.FilePath.length > 0" class="view" href={{doc.FilePath}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                   ng-reflect-placement="top" triggers="hover">
                  <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                </a>
                <a [ngClass]="{'disable-link':property.IsDeleted}" href="javascript:void(0);" (click)="openDeleteModal(RemoveFile, '', doc.Id);" class="remove" tooltip="Remove" placement="top">
                  <i class="icofont icofont-close" aria-hidden="true"></i>
                </a>
            </td>
            <td [hidden]="!(_authenticationService.Broker() || _authenticationService.Admin() || _authenticationService.SuperAdmin())">
              <label class="custom-checkbox withoutlabel" *ngIf="doc.CategoryId != 401">
                <input type="checkbox" [(ngModel)]="doc.IncludeInDD" (change)="showHideInDD(doc);">
                <i></i>
              </label>
            </td>
            <td>
              <p>{{doc.Name}}</p>
            </td>
            <td>
              <p>{{doc.Category}}</p>
            </td>
            <td>
              <p>{{doc.UploadedBy}}</p>
            </td>
            <td>
              <p>
                {{doc.UploadedDate ? (Validation.formatDate(Validation.convertUTCDateToLocalDate(doc.UploadedDate), 'MM/dd/yyyy')) : '-'}}
              </p>
            </td>

          </tr>
        </ng-container>
      </tbody>
      <tr *ngIf="propertyDocuments.length === 0&&!IsLoading">
        <td colspan="6" style="text-align: center; font-weight: normal; color: gray">

          <div class="nodata">
            <i class="icofont icofont-warning icon"></i>
            <p>No Documents Added</p>
          </div>
        </td>
      </tr>
    </table>
  </div>
 </div>
<ng-template #UploadFile>
  <div class="modal-body modal-scroll-body padding30">
    <app-offer-files-tab [inputOfferGuid]="" [RefreshTab] ="'Property-Files'" [modalRefUpload]="modalRefFile" [BackgroundFileStoring]="BackgroundFileStoring" [propertyId]="propertyId" (fileUploaded)="refreshFiles($event)" [fileTypes]="fileTypes"></app-offer-files-tab>
  </div>
</ng-template>
<ng-template #RemoveFile>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Remove File</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefDelete.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <h6 class="displayvalue">Are you sure to remove this file ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRefDelete.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="onRemoveDocument();">Remove</button>
        </div>
    </div>

</ng-template>

<ng-template #EditFile>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit File</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefEdit.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">File Category</label>
      <label class="select">
        <select class="form-control" [(ngModel)]="categoryId">
          <option *ngFor="let cat of categoryList" [ngValue]="cat.id">{{cat.name}}</option>
        </select>
        <i></i>
      </label>
    </div>

    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefEdit.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="UpdateDocCategory();">Save</button>
    </div>
  </div>

</ng-template>

<ng-template #preview>
  <div class="modal-header">
    <!--<h4 class="modal-title pull-left">{{docPreview.Name}}</h4>-->
    <button type="button" class="close pull-right" aria-label="Close" (click)="documentPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ngx-extended-pdf-viewer [src]="docPreview.FilePath" [showBookmarkButton]="false" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>

  <!--<pdf-viewer [external-link-target]="'blank'" [show-all]="true" [show-borders]="true" [original-size]="true" [src]="docPreview.Url"
              [render-text]="true"
              style="display: block;"></pdf-viewer>-->
</ng-template>

<ng-template #addUsers>
  <app-add-user-to-dd [modalRef]="modalRef" [PropertyId]="propertyId"></app-add-user-to-dd>
</ng-template>
